import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/common.json";
import ru from "./locales/ru/common.json";

export const languages = ["ru", "en"] as const;
export type Language = (typeof languages)[number];

export const defaultNS = "common";
export const resources = {
  ru: { common: ru },
  en: { common: en },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: "ru",
    supportedLngs: languages,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "mystaff.lang",
      caches: ["localStorage"],
    },
  });

function syncHtmlLang(lng: string) {
  document.documentElement.lang = lng;
}
syncHtmlLang(i18n.resolvedLanguage ?? "ru");
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
